import React from 'react';
import BaseLayout from './src/layouts/base';

import './src/styles/global.scss';

export function wrapPageElement({ element, props }) {
	return <BaseLayout {...props}>{element}</BaseLayout>;
}
